module.exports = __webpack_public_path__ + "img/smeClassification.424cd44e.svg";